
import { LocationIcon } from "../../icons/locationIcon"
import { MapIcon } from "../../icons/mapIcon"
import { PhoneIcon } from "../../icons/phoneIcon"
import { RadioGroupItem } from "../ui/Radio"

export const ServiceStation = ({station, hasAuth}) => {
    return (
        <div className="py-6 px-4 bg-white flex flex-col gap-2 rounded-[12px]" style={{
            boxShadow: '0px 2px 6px 0px #63636333'
        }}>
            <div className="flex w-full justify-end">
                {!hasAuth && <RadioGroupItem value={station} id={station.value} />}
            </div>
            <div className="flex w-full justify-between items-center">
                <h6>{station.name}</h6>
                {hasAuth && <MapIcon onClick={() => {window.open(`http://maps.google.com/maps?&z=15&q=${station.coordinates.lat}+${station.coordinates.lng}`, '_blank') }} className={'p-1 h-6 w-6 cursor-pointer rounded-full border border-[#A5A5A5]'} />}
            </div>
            {hasAuth ? 
                <>
                    <p className="text-disclaimer w-[90%]">Κατασκευαστής: {station.make}</p>
                    <p className="text-disclaimer w-[90%]">Διεύθυνση: {station.address}</p>
                    <p className="text-disclaimer w-[90%]">Νομός: {station.county}</p>
                    <p className="text-disclaimer w-[90%]">Περιοχή: {station.region}</p>
                    <div className="flex gap-1 items-center">
                        <PhoneIcon />
                        <p className="text-disclaimer">+30{station.phones.join(',+30')}</p>
                    </div>
                </> :
                <>
                 <div className="flex gap-1">
                    <LocationIcon />
                    <p className="text-disclaimer w-[90%]">{station.address}</p>
                </div>
                <div className="flex gap-1 items-center">
                    <PhoneIcon />
                    <p className="text-disclaimer">+30{hasAuth ? station.phones.join(',+30') :station.phone}</p>
                    </div>
                </>
            }
        </div>
    )
}